module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_close02-91f64d52575aa656663d3cb06ebe25bb.svg";